import { createApi } from '@reduxjs/toolkit/query/react'

import { FeatureType } from 'clickNgo/configs/feature'
import { axiosProcedureQuery } from 'clickNgo/helpers/api/axiosProcedureQuery'
import { IForm } from 'core-components/classes/models/IForm'

import { CampaignApiTags } from './models'

// The single RTK Query api instance for the campaign entity. Domain endpoint
// modules in ./endpoints attach their endpoints via injectEndpoints; the
// aggregator (./campaignApi.ts) imports them all and re-exports this instance
// as `campaignApi`, so the store registration stays unchanged.
export const campaignBaseApi = createApi({
  reducerPath: `${FeatureType.CngApi}/campaignApi`,
  // Tag types used for cache invalidation and refetch logic.
  // ALL tags must be declared here — injectEndpoints cannot add tag types.
  tagTypes: [
    CampaignApiTags.CampaignsByOwner,
    CampaignApiTags.CampaignsByISR,
    CampaignApiTags.CampaignObjectives,
    CampaignApiTags.CampaignDocuments,
    CampaignApiTags.CampaignCallingList,
    CampaignApiTags.CampaignRatings,
    CampaignApiTags.CampaignCallOutcomes,
  ],
  baseQuery: axiosProcedureQuery<IForm[]>(),
  endpoints: () => ({}),
})
